<template>
  <div class="graphContainer">
    <div class="graphConfigs">
      <h1>{{ title }}</h1>
    </div>
    <div class="table-wrapper">
      <v-data-table ref="dataTable" dense fixed-header :headers="finalHeaders" :items="keyData"
        :server-items-length="pagination ? pagination.totalItems : undefined" :options.sync="options"
        :page="pagination ? pagination.page : undefined" :item-class="() => 'dataItem'" class="elevation-1 table"
        :search="search" loading-text="Loading... Please wait" @click:row="openModalCallback"
        :items-per-page="itemsPerPage" :items-per-page-options="0" @update:page="page = $event"
        @update:items-per-page="itemsPerPage = $event" :footer-props="{ 'show-current-page': pagination }">
        <template v-slot:[`item.priority`]="{ item }">
          <v-chip :class="getClassForSeverity(item.priority)" label>
            {{ item.priority }}
          </v-chip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :class="getClassForStatus(item.status)" label>
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:[`item.current_status`]="{ item }">
          <v-chip :class="getClassForKeyStatus(item.current_status)" label>
            {{ item.current_status }}
          </v-chip>
        </template>
        <!-- <template v-slot:top>
          <v-text-field
            v-model="localSearch"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            class="mx-4"
          ></v-text-field>
        </template> -->
      </v-data-table>
    </div>
  </div>
</template>
<script>
import * as Constants from "../../../js/constants";

export default {
  props: ["configuration", "title", "tableData", "openModalCallback", "search", "headers", "processInputData", "pagination"],
  watch: {
    tableData: function (newVal, oldVal) {
      //must now check to see whats being passed to determin what headers to use
      if (this.headers != null) {
        console.log("Headers passed in", this.headers, this.processInputData)

        this.finalHeaders = this.headers
        this.keyData = this.processInputData ? this.processInputData(this.tableData) : this.mapData(this.tableData);
        this.$nextTick(() => {
          this.updateFooterPosition()
        })
        return
      }
      switch (this.configuration) {
        case Constants.GATE: {
          this.finalHeaders = this.keyHeaders;
          break;
        }

        case Constants.INCIDENTS: {
          this.finalHeaders = this.incidentHeaders;
          break;
        }

        case Constants.USERS: {
          console.log("users!");
          this.finalHeaders = this.usersHeaders;
          break;
        }
        case Constants.MAINTENANCE: {
          console.log("users!");
          this.finalHeaders = this.maintenaceHeaders;
          break;
        }
        case Constants.FREQUENT_VISITORS: {
          console.log("users!");
          this.finalHeaders = this.frequentVisitorsHeaders;
          break;
        }
      }

      // watch it
      this.keyData = this.processInputData ? this.processInputData(this.tableData) : this.mapData(this.tableData);
      console.log("tableData changed: ", newVal, " | was: ", oldVal);
      this.$nextTick(() => {
        this.updateFooterPosition()
      })
    },
    options: {
      deep: true,
      handler(val) {
        this.$emit('options-changed', val)
      }
    }
  },
  methods: {
    mapData(inputData) {
      let unitNums = ['A2', 'B5', 'C3', 'T6', 'A5', 'B9', 'D7']
      try {
        return inputData.map((item, index) => {
          if (this.configuration == Constants.USERS) {
            return {
              ...item,
              address: item.address,
              email: item['primary_email_address'],
              name: `${item.first_name} ${item.last_name}`,
              phone: item['primary_phone_number'],
              role: item.role,
              subdivision: item.subdivision,
            };
          } else if (this.configuration == Constants.GATE) {
            return {
              ...item,
              key_id: item.key_id,
              visitor_name: `${item.visitor_first_name} ${item.visitor_last_name}`,
              resident_name: `${item.user_first_name} ${item.user_last_name}`,
              unit: unitNums[index % 4],
              rules_accepted_display: `${item.rules_accepted ? "Yes" : "No"}`,
              time_active_table_value: item.time_active ? `${this.formattedDate(item.time_active)} ${this.formattedTime(item.time_active)}` : `${this.formattedDate(item.time_created)} ${this.formattedTime(item.time_created)}`,
              time_last_updated_table_value: item.time_last_updated ? `${this.formattedDate(item.time_last_updated)} ${this.formattedTime(item.time_last_updated)}` : `${this.formattedDate(item.time_last_updated)} ${this.formattedTime(item.time_last_updated)}`,
              //time_validated: item.time_validated ? `${this.formattedDate(item.time_active)} ${this.formattedTime(item.time_active)}` : `${this.formattedDate(item.time_created)} ${this.formattedTime(item.time_created)}`,
              expiration: item.expiration_time ? `${this.formattedDate(item.expiration_time)} ${this.formattedTime(item.expiration_time)}` : `${this.formattedDate(item.time_created)} ${this.formattedTime(item.time_created)}`,
              party_name: item.party_id,
            };
          } else if (this.configuration == Constants.INCIDENTS) {
            return {
              ...item,
              incident_id: item.incident_id,
              title: item.title,
              description: item.description,
              incident_type: item.incident_type,
              reporter: item.reporter,
              time_created: `${this.formattedDate(item.time_created)} ${this.formattedTime(item.time_created)}`,
              current_status: item.current_status,
              priority: item.priority,
              location: item.location,
              time_closed: item.time_closed,
            }
          } else {
            return {
              ...item,
              frequent_visitor_name: `${item.first_name} ${item.last_name}`,
              visitor_name: `${item.visitor_first_name} ${item.visitor_last_name}`,
              authorizer_name: `${item.authorizer_first_name} ${item.authorizer_last_name}`,
              resident_name: `${item.resident_first_name} ${item.resident_last_name}`,
              readable_entry_time: `${new Date(item.time_entry).toLocaleString()}`,
              time_created: this.formattedDate(item.time_created)
            }
          }

          // name email phone address subdivision role
        });
      } catch (e) {
        console.log("Error", e);
      }
    },
    getClassForSeverity(severity) {
      switch (severity) {
        case "Urgent":
          return "high";
        case "High":
          return "high";
        case "Medium":
          return "medium";
        case "Low":
          return "low";
      }
      return ""
    },
    getClassForStatus(severity) {
      switch (severity) {
        case "BLOCKED":
          return "high";
        case "High":
          return "high";
        case "Medium":
          return "medium";
        case "IN REVIEW":
          return "low";
      }
      return ""
    },
    getClassForKeyStatus(severity) {
      switch (severity) {
        case "CANCELED":
        case "BLOCKED":
          return "high";
        case "High":
          return "high";
        case "Medium":
          return "medium";
        case "CREATED":
        case "OPEN":
          return "pending";
        case "Occupied":
          return "occupied";
        case "VALIDATED":
          return "redeemed"
        case "ACTIVE":
          return "low";
        case "Vacant":
          return "vacant";
        case "Pending":
          return "pending";
      }
      return ""
    },
    formattedDate(dateString) {
      let date = new Date(dateString);
      let today = new Date();

      var formattedDate;

      if (date.getMonth() == today.getMonth() && date.getDate() == today.getDate()) {
        formattedDate = "Today";
      } else {
        formattedDate = date.toLocaleDateString()
      }

      return formattedDate;
    },
    formattedTime(dateString) {
      return new Date(dateString).toLocaleTimeString()
    },
    updateFooterPosition() {
      this.$nextTick(() => {
        const table = this.$refs.dataTable
        if (!table || !table.$el) return

        const tableEl = table.$el
        const footer = tableEl.querySelector('.v-data-footer')

        const scrollBody = tableEl.querySelector('.v-data-table__wrapper')


        if (!footer || !scrollBody) return

        const rect = tableEl.getBoundingClientRect()
        const viewportHeight = window.innerHeight
        const tableBottom = rect.bottom
        const footerHeight = footer.offsetHeight
        const topOffset = rect.top

        const availableHeight = viewportHeight - topOffset - footerHeight

        scrollBody.style.maxHeight = `${availableHeight}px`


        const shouldFix = tableBottom > viewportHeight

        if (shouldFix) {
          footer.style.position = 'fixed'
          footer.style.bottom = '0'
        } else {
          footer.style.position = 'static'
        }

        footer.style.left = rect.left + 'px'
        footer.style.width = rect.width + 'px'

      })
    }
  },
  mounted() {
    this.updateFooterPosition()
    window.addEventListener('resize', this.updateFooterPosition)
    //window.addEventListener('scroll', this.updateFooterPosition)

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateFooterPosition)
    //window.removeEventListener('scroll', this.updateFooterPosition)

  },
  updated() {
    console.log("keyData updated", this.keyData);
  },
  data() {
    return {
      left: 0,
      right: 0,
      footerStyle: {},
      finalHeaders: [],
      keyHeaders: [
        { text: "Key ID", align: "start", sortable: false, value: "key_id", },
        { text: "Visitor Name", value: "visitor_name", width: '2em' },
        { text: "Resident Name", value: "resident_name", },
        { text: "Time Active", value: "time_active_table_value", width: 180 },
        { text: "Expiration", value: "expiration", width: 180 },
        { text: "Time Validated", value: "time_validated", width: 180 },
        { text: "Party Name", value: "party_name" },

        { text: "Time Active1", value: "time_active_table_value", width: 180 },
        { text: "Expiration1", value: "expiration", width: 180 },
        { text: "Time Validated1", value: "time_validated", width: 180 },
      ],
      incidentHeaders: [
        { text: "Incident Title", value: "title", align: "start", sortable: true, width: 300 },
        { text: "Resolution Status", value: "current_status", filterable: true, width: 175 },
        { text: "Incident Type", value: "incident_type", filterable: false, width: 175 },
        { text: "Current Assignee", value: "reporter", filterable: false, width: 180 },
        { text: "Time Created", value: "time_created", filterable: false, width: 180 },
        { text: "Incident Location", value: "location", filterable: false, width: 175 },
        { text: "Severity Level", value: "priority", filterable: false, width: 180 },
        { text: "Assigned Personnel", value: "reporter", filterable: false, width: 180 },
        { text: "Resolution Date", value: "time_closed", filterable: false, width: 180 },
        { text: "Police Case Number", value: "incident_id", filterable: false, width: 180 },
        { text: "Incident ID", value: "incident_id", align: "start", sortable: true, width: 160 },
      ],
      usersHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Phone Number", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Address", value: "address" },
        { text: "Status", value: "current_status", default: "Active" },
        { text: "Role", value: "role" },
        { text: "Subdivision", value: "subdivision" },
        //{ text: "Move In Date", value: "address" },
      ],
      maintenaceHeaders: [
        { text: "Title", value: "title", align: "start", sortable: true, width: 300 },
        { text: "Status", value: "current_status", filterable: true, width: 175 },
        { text: "Category", value: "category", width: 175 },
        { text: "Priority", value: "priority", filterable: false, width: 180 },
        { text: "Location", value: "location", filterable: false, width: 180 },
        { text: "Assigned To", value: "assignee", filterable: false, width: 175 },
        { text: "Due Date", value: "due_date", filterable: false, width: 180 },
        { text: "Created By", value: "reporter", filterable: false, width: 180 },
        { text: "Time Created", value: "time_created", filterable: false, width: 180 },
        { text: "Closed Date", value: "time_closed", filterable: false, width: 180 },
        { text: "Maintenance ID", value: "maintenance_id", align: "start", sortable: true, width: 160 },
      ],
      entryLogHeaders: [
        { text: "Visitor Name", value: "visitor_first_name", align: "start", sortable: true, width: 300 },
        { text: "Resident Name", value: "resident_uid", filterable: true, width: 175 },
        { text: "Visiting Address", value: "visiting_address", width: 175 },
        { text: "Visitor Entry Time", value: "entry_time", filterable: false, width: 180 },
        { text: "Guard Attendant", value: "location", filterable: false, width: 180 },
        { text: "Visitor License Plate", value: "assignee", filterable: false, width: 175 },
        { text: "Visitor Contact", value: "due_date", filterable: false, width: 180 },
        { text: "Visitor Type", value: "reporter", filterable: false, width: 180 },
        { text: "Vendor Name", value: "time_created", filterable: false, width: 180 },
        { text: "Party Key", value: "time_closed", filterable: false, width: 180 },
        { text: "Visit ID", value: "maintenance_id", align: "start", sortable: true, width: 160 },
      ],
      frequentVisitorsHeaders: [
        { text: "Frequent Visitor Name", value: "visitor_name", align: "start", sortable: true, width: 300 },
        { text: "Resident Name", value: "resident_uid", filterable: true, width: 175 },
        { text: "Visiting Address", value: "resident_uid", width: 175 },
        { text: "Date Added", value: "time_created", filterable: false, width: 180 },
        { text: "Expiration", value: "expiration", filterable: false, width: 180 },
        { text: "Visitor Relationship", value: "visitor_relationship", filterable: false, width: 175 },
        { text: "Visitor License Plate", value: "visitor_license_plate", filterable: false, width: 180 },
        { text: "Times Visited", value: "times_visited", filterable: false, width: 180 },
        { text: "Visitor Email", value: "visitor_email", filterable: false, width: 180 },
        { text: "Visitor Phone Number", value: "visitor_phone_number", filterable: false, width: 180 },
        { text: "Resident Phone Number", value: "resident_uid", filterable: false, width: 180 },
        { text: "Resident Email Address", value: "resident_uid", align: "start", sortable: true, width: 160 },
        { text: "Frequent Visitor ID", value: "id", align: "start", sortable: true, width: 160 },
      ],
      keyData: [],
      localSearch: "",
      itemsPerPage: 100,
      page: 1,
      options: {}
    };
  },
};
</script>
<style>
.graphContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  margin-bottom: 16px;
}

.table-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  position: relative;
  /* match footer height */

  /* background-color: #699991; */
}

.graphReportTitle {
  color: white;
  margin: 0px;
  display: block;
  text-align: left;
}

.graphConfigs {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.graphConfigs h1 {
  color: #87bab7;
  text-align: left;
  font-size: 48px;
}

.graphConfigs select {
  background-color: #87bab7;
  text-align: left;
  border: 0px solid white;
  border-radius: 0px;
  height: 48px;
  color: white;
  font-size: 24px;
  padding: 8px;
}

.graphConfigs select option {
  background-color: #87bab7;
  text-align: center;
  border: 0px solid white;
  border-radius: 0px;
  height: 48px;
  width: 400px;
  color: white;
  font-size: 24px;
  margin: 16px;
  float: left;
}

.table {
  background-color: #87bab7;
  padding-bottom: 6px;

}

.table-wrapper::-webkit-scrollbar {
  height: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

.table-wrapper .v-data-table__wrapper {
  /* height of footer */
  box-sizing: content-box;
}


.v-data-table__wrapper {
  background-color: #D9D9D9;
  color: white;
  border-radius: 0px;
  overflow-x: auto;
  box-sizing: content-box;
  overflow-y: scroll;
}

.v-data-table__wrapper table tbody tr:hover td {
  color: black;
  background-color: #69999140;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition: 0.5s;
}

.v-data-table--dense .v-data-table__wrapper table tbody tr td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.v-data-table--dense .v-data-table__wrapper table tbody tr {
  border-radius: 25px;
}

.v-data-table-header tr th span {
  background-color: #D9D9D9;
  color: black;
  font-weight: 600;
}

.v-data-table-header__icon tr th i {
  color: white;
}

.v-data-table elevation-1 table v-data-table--has-top v-data-table--has-bottom theme--light {
  border-radius: 4px;
  width: 99%;
}

/* When fixed to viewport */
.table .v-data-footer.is-fixed {
  position: fixed;
  bottom: 0;
  z-index: 10;
}

/* When inside table (normal flow) */
.table .v-data-footer.is-static {
  position: static;
}

.v-data-footer {
  display: flex;
  height: 48px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  position: fixed;
  bottom: 0;
  background: white;
  z-index: 5;
  left: 0;
  right: 0;
}

.v-data-footer .v-select__selections {
  display: none;
}

.v-data-footer__select {
  display: none;
}

.v-data-footer .v-data-footer__pagination {
  display: flex;
  justify-content: center;
  /* Align pagination to center */
}

.dataItem {
  background-color: white;
  color: black;
  text-align: left;
}

.text-start {
  color: black;
  min-width: 10em;
  text-align: left;
}

.theme--light.v-data-table.v-data-table--fixed-header thead th {
  background-color: #D9D9D9 !important;
  z-index: 1 !important;
}

.high {
  background-color: #FFDBDB !important;
  color: red !important;
  width: 116px;
  text-align: center !important;
}

.high span {
  width: 100%;
  display: flex !important;
  text-align: center;
  justify-content: center;
}

.medium {
  background-color: #FFEC8988 !important;
  width: 116px;
  text-align: center !important;
}

.medium span {
  width: 100%;
  display: flex !important;
  text-align: center;
  justify-content: center;
}

.low {
  background-color: rgba(135, 186, 183, 0.50) !important;
  width: 116px;
  text-align: center !important;
}

.low span {
  width: 100%;
  display: flex !important;
  text-align: center;
  justify-content: center;
}

.redeemed {
  background-color: #699991 !important;
  width: 116px;
}

.redeemed span {
  width: 100%;
  display: flex !important;
  text-align: center;
  justify-content: center;
  text-align: center !important;
  color: white;
  font-weight: 600;
}

.occupied {
  background: rgba(135, 186, 183, 0.50) !important;
  width: 116px;
}

.occupied span {
  width: 100%;
  display: flex !important;
  text-align: center;
  justify-content: center;
  text-align: center !important;
}

.pending {
  background: #D5D5D5 !important;
  width: 116px;
}

.pending span {
  width: 100%;
  display: flex !important;
  text-align: center;
  justify-content: center;
  text-align: center !important;
}

.vacant {
  background: #FFDBDB !important;
  width: 116px;
}

.vacant span {
  width: 100%;
  display: flex !important;
  text-align: center;
  justify-content: center;
  text-align: center !important;
}

.span {
  width: 100%;
  border-radius: 4px;
  display: flex !important;
  text-align: center;
  justify-content: center;
}
</style>